<template>
    <div></div>
</template>
<script>
    export default {
        props: [
            'notification'
        ],
        mounted: function() {
            switch(parseInt(this.notification)) {
                case 1:
                    this.loginFailed();
                    break;
                case 2:
                    this.loginComplete();
                    break;
                case 3:
                    this.registrationComplete();
                    break;
                case 4:
                    this.registrationFailed();
                    break;
                case 5:
                    this.logoutComplete();
                    break;
                case 6:
                    this.cartNotSignedIn();
                    break;
                case 7:
                    this.orderFinished();
                    break;
                case 8:
                    this.specifyNotSignedIn();
                    break;
                case 9:
                    this.accountPasswordUpdated();
                    break;
                case 10:
                    this.accountPasswordResetSent();
                    break;
                case 15:
                    this.accountSuccesfullyUpdated();
                    break;
                case 16:
                    this.generalException();
                    break;
                case 17:
                    this.orderOfferFinished();
                    break;
                case 99:
                    this.emptyLocalStorageShoppingcart();
                default:
                    break;
            }
        },
        methods: {
            loginFailed: function() {
                // Notification 1
                this.$awn.alert("Uw login gegevens zijn incorrect of uw account is nog niet goedgekeurd");
                $(".login-popup-btn").click();
            },
            loginComplete: function() {
                // Notification 2
                this.$awn.success("U bent succesvol ingelogd");
            },
            registrationComplete: function() {
                // Notification 3
                this.$awn.success("Uw registratie is ontvangen, wij nemen zo spoedig mogelijk contact met u op");
            },
            registrationFailed: function() {
                // Notification 4
                $(".register-popup").click();
                this.$awn.alert("Het registratieformulier heeft een aantal fouten")
            },
            logoutComplete: function() {
                // Notification 5
                console.log("logout complete");
                this.$awn.success("U bent succesvol uitgelogd");
            },
            cartNotSignedIn: function() {
                // Notification 6
                console.log("Cart not signed in");
                this.$awn.info("Uw moet ingelogd zijn om de winkelmand te kunnen bekijken");
            },
            orderFinished: function() {
                // Notification 7
                this.$awn.success("Uw order is succesvol afgerond, wij nemen zo spoedig mogelijk contact met u op!");
            },
            orderOfferFinished: function() {
                // Notification 17
                this.$awn.success("Uw aanvraag is succesvol ontvangen, wij nemen zo spoedig mogelijk contact met u op!");
            },
            specifyNotSignedIn: function() {
                // Notification 8
                this.$awn.info("Uw moet ingelogd zijn om een kwaliteit te specificeren");
            },
            accountPasswordUpdated: function() {
                // Notification 9
                this.$awn.success("Uw wachtwoord is hersteld");
            },
            accountPasswordResetSent: function() {
                // Notification 10
                this.$awn.success("Er is een herstel link naar uw e-mail verzonden");
            },
            accountSuccesfullyUpdated: function(){
                // Notification 15
                this.$awn.success("Uw accountgegevens zijn succesvol bijgewerkt");
            },
            emptyLocalStorageShoppingcart: function() {
                localStorage.setItem('guestShoppingcart', JSON.stringify([]));
            },
            generalException: function() {
                this.$awn.alert("Daar ging iets mis.")
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/notification.vue